export enum PaymentMethodEnum {
  CARD_ONLINE = 4,
  CARD_PAYMENT = 50,
  GOOGLE_PAY = 51,
  APPLE_PAY = 52,
  FIRE_OPEN_PAYMENTS = 53,
  CARD_COLLECT = 54,
  STRIPE = 56,
  AIB = 70,
  BANK_TRANSFER = 57,
  DIRECT_DEBIT = 58,
  SURFBOARD = 71
}

export enum PaymentMethodCodeEnum {
  SURFBOARD = 'SRF'
}
